// extracted by mini-css-extract-plugin
export var spin = "style-module--spin--6ffba";
export var spinner = "style-module--spinner--f1872";